module.exports = __webpack_public_path__ + "static/media/9pulgadasaceroinoxidable.aeeee669.jpg";